import { List as WdsList, ListProps as WdsListProps } from "@datamole/wds-component-list";
import { type Ref, forwardRef, type PropsWithoutRef } from "react";

type Props<TAsChild extends boolean = false> = PropsWithoutRef<WdsListProps<TAsChild>>;

type RefProp<TAsChild extends boolean = false> = TAsChild extends true ? never : Ref<HTMLUListElement>;

const List = <TAsChild extends boolean = false>(props: Props<TAsChild>, ref: RefProp<TAsChild>) => {
    const { asChild, ...otherProps } = props;

    return <WdsList {...otherProps} asChild={asChild} ref={ref} />;
};

// TODO: can be simplified by not disabling ref when `asChild` is true in List
const ListWithForwardedRef = forwardRef(List) as (<TAsChild extends boolean = false>(
    props: Props<TAsChild> & { ref?: RefProp<TAsChild> }
) => ReturnType<typeof List>) & { displayName: string };

ListWithForwardedRef.displayName = "Menu.Content.List";

export { ListWithForwardedRef as MenuContentList };

export type { Props as MenuContentListProps };
